import React from 'react';
import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import ModalCustomized from '../../../../components/Modal/Modal';
 
export default function ModalDocumentosSeparados({ isOpen, toggle, itens, onSelecionar }) {
    return (
        <ModalCustomized
            toggle={toggle}
            isOpen={isOpen}
            btnClose={toggle}
            size={'lg'}
            fullscreen={"lg"}
            widthPadrao={false}
            title={"Selecionar Documento"}
        >
            <Row className='d-flex flex-column justify-content-center align-items-center mt-2'>
                {itens.map((item) => (
                    <Col md={12} lg={12} className="mb-2" key={item.hash}>
                        <Button
                            color='secondary'
                            className='text-white fw-bold w-100'
                            onClick={() => onSelecionar(item)}
                        >
                            <FontAwesomeIcon icon={faFilePdf} className="me-2" />{" "}
                            {item.identificacao}
                        </Button>
                    </Col>
                ))}
            </Row>
        </ModalCustomized>
    );
}
